export const lmDevicesUsersInitialState = {

  // --- Device Stats ---
  deviceStats: {
    ttlDvc: 0,
    actDvc: 0,
  },
  deviceStatsLoading: false,
  deviceStatsError: null,

  // --- Device List ---
  devices: [],
  devicesLoading: false,
  devicesError: null,
  devicesTotalRecords: 0,
  isDevicesLastPage: false,
  selectedDevice: null,
  devicesFilters: {
    pageNo: 1,
    pageSize: 6,
    searchTerm: '',
    isActive: null,
    sortBy: '',
  },

  // --- User Stats ---
  userStats: {
    ttlUsrCnt: 0,
    actUsrCnt: 0,
  },
  userStatsLoading: false,
  userStatsError: null,

  // --- User List ---
  users: [],
  usersLoading: false,
  usersError: null,
  usersTotalRecords: 0,
  isUsersLastPage: false,
  selectedUser: null,
  usersFilters: {
    pageNo: 1,
    pageSize: 6,
    searchTerm: '',
    isActive: null,
    sortBy: '',
  },

  // --- Users for a Device ---
  deviceUsers: [],
  deviceUsersLoading: false,
  deviceUsersError: null,

  // --- Devices for a User ---
  userDevices: [],
  userDevicesLoading: false,
  userDevicesError: null,

  // --- Extension Installs ---
  extensionInstalls: [],
  extensionInstallsLoading: false,
  extensionInstallsError: null,

  // --- General ---
  userMsg: null,
  statusCode: null,
}
